export const colors = {
  primary: "#111111",
  white: "#f7f4ee",
  hightlight: "#ffffff1a",
  dark: "rgb(38, 38, 38)",
  black: "#000000",
  modalHeading: "#111111",
  lightYellow: "#faeaa7",
  modalBackground: "#FED7AA",
  darkModalBackground: "#FAC473",
  error: "#F10917",
  success: "#15803D",
  grey: "#A3A3A3",
  lightPrimary: "#A3A3A3",
  lightGrey: "#d7d2c880",
  lighterGrey: "#CFCFCF",
  lightestGrey: "#FAFAFA",
  lightBlack: "#262626",
  lighterBlack: "#171717",
  darkRed: "#B22222",
  darkerRed: "#8B0000",
  red: "#D32F2F",
  lightRed: "#FECACA",
  lightGreen: "#BBF7D0",
  lightBlue: "#BFDBFE",
  darkGreen: "#4DA154",
};
